// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"b0c897a6","261":"2d900a38","286":"94ca73d8","437":"f0056ee8","612":"5dd5149a","787":"d806e9ca","847":"a743b130","956":"962beb84"}[chunkId] + ".chunk.js";
};